import {IconDefinition} from '@fortawesome/free-solid-svg-icons';
import {faLaptopCode} from '@fortawesome/free-solid-svg-icons/faLaptopCode';
import {faPuzzlePiece} from '@fortawesome/free-solid-svg-icons/faPuzzlePiece';
import {faGamepad} from '@fortawesome/free-solid-svg-icons/faGamepad';
import {faPencilRuler} from '@fortawesome/free-solid-svg-icons/faPencilRuler';
import {faMusic} from '@fortawesome/free-solid-svg-icons/faMusic';
import {faHeadset} from '@fortawesome/free-solid-svg-icons/faHeadset';
import {faCode} from '@fortawesome/free-solid-svg-icons/faCode';
import {faClock} from '@fortawesome/free-solid-svg-icons/faClock';

export class Skill {
  title: string;
  description: string;
  icon: IconDefinition;
}

export const DEVELOPMENT_SKILLS: Skill[] = [
  {
    title: 'Chiptunes',
    description: 'Using GXSCC to turn Midis into chiptunes since 2013.',
    icon: faGamepad
  }
];

export const FRAMEWORK_SKILLS: Skill[] = [
  {  
    title: 'Basic reverse-engineering',
    description: 'ye',
    icon: faPuzzlePiece
  }
];


export const TOOLS_SKILLS: Skill[] = [
  {
  
    title: ' ',
    description: ' ',
    icon: faCode
  }
];
